const Button = (props: any) => (
  <div
    className="ml-auto mr-sm-5 mr-sm-5 mb-2 mt-2"
    id="global-btn-id"
  >
    <button
      disabled={props.disabled}
      className={props.className}
      id={props.id}
      onClick={props.onClick}
      data-testid={props["data-testid"]}
    >
      {props.children}
    </button>
  </div>
);
export default Button;